import { render } from "./PaginationNavigationComponent.vue?vue&type=template&id=4c44f059"
import script from "./PaginationNavigationComponent.vue?vue&type=script&lang=js"
export * from "./PaginationNavigationComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__